import { render, staticRenderFns } from "./feedbackEditor.vue?vue&type=template&id=2eca0028&scoped=true"
import script from "./feedbackEditor.vue?vue&type=script&lang=js"
export * from "./feedbackEditor.vue?vue&type=script&lang=js"
import style0 from "./feedbackEditor.vue?vue&type=style&index=0&id=2eca0028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca0028",
  null
  
)

export default component.exports